const Config = {
    ApiKey: '947342716f47a77f295c5eb4af73e29e',
    url: "https://api.openweathermap.org/data/2.5/weather?",
    Units: "metric"
  };
  
export default Config;